import { type MouseEvent, useCallback } from 'react';

import { usePostHog } from 'posthog-js/react';

import { useZendesk } from 'components/Zendesk';
import { posthogEvents } from 'constants/posthogEvents';
import { useLogoutMutation } from 'store/api';
import { PersistService } from 'utils/persist';

export function useSignOut() {
  const posthog = usePostHog();
  const { logoutUser } = useZendesk();
  const [logout] = useLogoutMutation();

  return useCallback(
    async (e?: MouseEvent<HTMLElement>, shouldCapture = true) => {
      e?.preventDefault();

      PersistService.set('auth.justSignedOut', true);
      PersistService.remove('campaignParams');

      if (shouldCapture) {
        posthog?.capture(posthogEvents.auth.signOut);
      }

      posthog?.reset();
      logoutUser();

      try {
        await logout().unwrap();
      } catch {
        // noop
      }
    },
    [logout, logoutUser, posthog],
  );
}
